<template>
  <div class="p-6">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t('frontend_groovemail_mail_list_name') }}
      </label>
      <text-input
        variant="base"
        v-model="model.name"
        :placeholder="$t('frontend_groovemail_adminsetting_name')"
        :validator="$v.model.name"
      />
    </div>
    <div class="flex justify-end">
      <gs-button
        variant="outline"
        @click="closeListModal()"
        >{{ $t('frontend_cancel') }}</gs-button
      >
      <gs-button
        class="ml-2"
        variant="primary"
        @click="type === 'add' ? createMaillist() : editMaillist()"
      >
        {{
          type === 'add'
            ? $t('frontend_groovemail_mail_list_create_list')
            : $t('frontend_groovemail_mail_list_update')
        }}
      </gs-button>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Maillist from '@/models/Maillist';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

export default {
  data() {
    return {
      model: {
        name: '',
      },
      isLoading: false,
    };
  },

  props: {
    type: {
      required: true,
    },
    mail_list_id: {
      required: true,
    },
    mail_list_data: {
      required: true,
    },
  },

  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },

  async created() {
    if (this.mail_list_data) {
      this.model.name = this.mail_list_data.name;
    }
  },

  methods: {
    async createMaillist() {
      this.$v.model.name.$touch();
      
      if (!this.$v.model.name.$invalid) {
        // show loader
        this.$emit('showLoader');

        const mailList = new Maillist({});
        mailList.name = this.model.name;
        // mailList.description = '';
        const createdList = await mailList.save()
        .then(() => {
          this.$emit('closeCreateMaillistModal');
          this.$v.model.name.$reset();
          // this.$v.model.description.$reset();
          this.$emit('fetchEventsList', createdList);
          // hide loader
          this.$emit('hideLoader');
        })
        .catch(e => {
          // hide loader
          this.$emit('hideLoader');
          this.showErrorModal(e.response.data.error);
        });
      }
    },
    closeListModal() {
      this.$emit('closeCreateMaillistModal');
      this.$emit('closeEditMaillistModal');
    },

    showErrorModal(error) {
      showAlert({
        iconType: 'alert-error',
        html : `
          <p class="text-sm text-deep-dark">${error}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    async editMaillist() {
      this.$v.model.name.$touch();
      // this.$v.model.description.$touch();

      if (!this.$v.model.name.$invalid) {
        // show loader
        this.$emit('showLoader');
        const mailList = await Maillist.$find(this.mail_list_id);
        mailList.name = this.model.name;
        // mailList.description = '';
        await mailList.save()
        .then(() => {
          this.$emit('closeEditMaillistModal');
          this.$v.model.name.$reset();
          // this.$v.model.description.$reset();
          this.$emit('fetchEventsList');
          this.$emit('hideLoader');
        })
        .catch(e => {
          // hide loader
          this.$emit('hideLoader');
          this.showErrorModal(e.response.data.error);
        });
      }
    },
  },
};
</script>
